import { UtensilsCrossed, X } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SwiggyLinkBanner({ sessionId, profile }) {
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("swiggyNudgeHidden") === "1");
  const [connected, setConnected] = useState(null);
  const [linking, setLinking] = useState(false);
  const isLoggedIn = !!profile;

  useEffect(() => {
    if (!sessionId || hidden || !isLoggedIn) return;
    axios
      .get(`${API}/swiggy/status`)
      .then((res) => setConnected(res.data.connected))
      .catch(() => setConnected(false));
  }, [sessionId, hidden, isLoggedIn]);

  if (hidden || !sessionId || !isLoggedIn || connected === null || connected === true) return null;

  const dismiss = () => {
    setHidden(true);
    sessionStorage.setItem("swiggyNudgeHidden", "1");
  };

  const linkNow = async () => {
    setLinking(true);
    try {
      const res = await axios.post(`${API}/swiggy/connect`, {});
      window.open(res.data.auth_url, "_blank", "noopener,noreferrer");
    } catch (e) {
      toast.info("Swiggy linking is still being set up with our partner — check back soon!");
    } finally {
      setLinking(false);
    }
  };

  return (
    <div
      className="mx-3 mt-2 md:mx-6 rounded-xl border border-orange-200 bg-orange-50 px-3 py-2.5 flex items-start gap-2.5"
      data-testid="swiggy-nudge-banner"
    >
      <UtensilsCrossed className="w-5 h-5 shrink-0 mt-0.5 text-orange-600" strokeWidth={1.75} />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-orange-900 font-medium leading-snug">
          Pre-link your Swiggy account now — so ordering food is instant the day it goes live.
        </p>
        <button
          onClick={linkNow}
          disabled={linking}
          className="inline-block mt-1.5 text-xs font-medium text-orange-700 underline underline-offset-2 hover:text-orange-900 disabled:opacity-60"
          data-testid="swiggy-nudge-link-btn"
        >
          {linking ? "Opening..." : "Link my Swiggy account →"}
        </button>
      </div>
      <button
        onClick={dismiss}
        className="p-1 -m-1 text-orange-600 hover:text-orange-900"
        aria-label="Dismiss"
        data-testid="swiggy-nudge-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
